import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserProfileSetting } from 'src/app/core/interface/auth.model';
import { SupplementaryAccountsService } from 'src/app/core/services/supplementary-accounts.service';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { UtilsService } from './../../../core/services/utils.service';



@Component({
  selector: 'app-setting-supplementary-account',
  templateUrl: './setting-supplementary-account.component.html',
  styleUrls: ['./setting-supplementary-account.component.scss']
})
export class SettingSupplementaryAccountComponent implements OnInit {
  @Input() userId;

  supplementaryAccountSettings = {
    discoverablity: false,
    message_ability: false,
    notification_consent: false,
    geographical_location: false,
    promotional_email: false,
    push_notification_to_parent_account: false,
    transferable: false,
    user_status: {
      type: false
    },
    make_connection: false,
    allow_to_create_publish_material: false,
    allow_to_buy_material: false,
    allow_to_download_material: false,
    who_can_see_connection: 0
  };

  changePasswordForm: FormGroup;
  changePasswordFormSubmitted = false;

  constructor(
    private activeModal: NgbActiveModal,
    private supplementaryAccountService: SupplementaryAccountsService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private utilService: UtilsService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.loadSetting();
    this.changePasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.pattern('^(?! )^.*(?<! )$'), Validators.minLength(6)]],
      password_confirmation: ['', Validators.required],
    }, {
      validator: this.utilService.mustMatch('password', 'password_confirmation')
    });
  }

  closeDialog() {
    this.activeModal.dismiss();
  }

  loadSetting() {
    this.supplementaryAccountService.fetchSetting(this.userId).subscribe(
      (response: any) => {
        if (response.success) {
          this.supplementaryAccountSettings = response.data.setting;
          if (response.data.setting.user_status.type == 'public_profile') {
            this.supplementaryAccountSettings.user_status.type = false;
          }
          else
            this.supplementaryAccountSettings.user_status.type = true;
        }
      });
  }
  whoCanSeeConnection() {

    const params: UserProfileSetting = {
      user_profile_setting: {
        who_can_see_connection: this.supplementaryAccountSettings.who_can_see_connection
      }
    };
    // this.spinner.show();
    this.supplementaryAccountService.updateConnectionSetting(params, this.userId).subscribe(
      (response: any) => {

        // this.spinner.hide();
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = 'Updated Successfully.';
        }
        else {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      },
      (error: any) => {
        this.spinner.hide();
      });
  }
  onPasswordChange() {
    this.changePasswordFormSubmitted = true;
    if (this.changePasswordForm.invalid) {
      return;
    }

    const params = {
      'supplementary_account': {
        password: this.utilService.encode(this.changePasswordForm.get('password').value),
        password_confirmation: this.utilService.encode(this.changePasswordForm.get('password_confirmation').value),
      }
    };

    this.supplementaryAccountService.updateSupplementaryUser(this.userId, params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.changePasswordForm.reset();
          this.changePasswordForm.markAsUntouched();
          this.changePasswordForm.markAsPristine();
          Object.keys(this.changePasswordForm.controls).forEach(key => {
            this.changePasswordForm.controls[key].setErrors(null);
          });
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = "Password updated Successfully.";
        }
        else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors || 'Error occured during updating a password.';
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      }, (error: any) => {
        this.spinner.hide();
        const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modelRef.componentInstance.message = error.errors || 'Error occured during updating a password.';
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }

  onSlideChange(type: any, value: any) {

    this.spinner.show();
    const params: UserProfileSetting = {
      user_profile_setting: {
        [type]: value
      }
    };

    type = (type == 'status' ? 'private_account' : type);

    this.supplementaryAccountService.updateSetting(type, params, this.userId).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = "Updated Successfully.";
        }
        else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = "Error occured during updating a setting.";
        }
      }, (error: any) => {
        // this.spinner.hide();
        const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modelRef.componentInstance.message = "Error occured during updating a setting.";
      })
  }
}
